var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDev(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 333.75 465.67",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: url(#linear-gradient-3);\n      }\n\n      .cls-1, .cls-2 {\n        stroke-width: 0px;\n      }\n\n      .cls-2 {\n        fill: url(#linear-gradient-2);\n        opacity: .19;\n      }\n\n      .cls-3 {\n        fill: none;\n        stroke: url(#linear-gradient);\n        stroke-linecap: round;\n        stroke-miterlimit: 10;\n        stroke-width: 1.32px;\n      }\n    "), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 35.1,
    y1: 458.32,
    x2: 296.43,
    y2: 5.68,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e7427e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#e53d75"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#df315e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#d71d38"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#d5182e"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 35.46,
    y1: 457.7,
    x2: 296.08,
    y2: 6.29,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 31.31,
    y1: 467.76,
    x2: 303.22,
    y2: -3.2,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#d5182e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#cc1f34"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#b53248"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#8f5267"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#5a7e92"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94,
    stopColor: "#17b6c9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#08c4d6"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_4",
    "data-name": "Layer 4"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M302.05,454.26H29.49c-7.5-7.5-11.7-11.7-19.2-19.2V28.94c7.5-7.5,11.7-11.7,19.2-19.2h272.56c7.5,7.5,11.7,11.7,19.2,19.2v406.11c-7.5,7.5-11.7,11.7-19.2,19.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M302.05,454.26H29.49c-7.5-7.5-11.7-11.7-19.2-19.2V28.94c7.5-7.5,11.7-11.7,19.2-19.2h272.56c7.5,7.5,11.7,11.7,19.2,19.2v406.11c-7.5,7.5-11.7,11.7-19.2,19.2Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M125.06,464.56H25.76L.77,439.57V176.26l2.06,2.92v259.54l23.78,23.78h96.99l1.46,2.06ZM117.7,0H25.76L.77,24.99v51.37l2.06,2.06V25.84L26.61,2.06h89.02l2.06-2.06ZM185.91,0h-25.78l-2.06,2.06h25.78l2.06-2.06ZM232.57,0h-23.46l-2.06,2.06h23.46l2.06-2.06ZM308.76,0h-52.99l-2.06,2.06h54.2l23.78,23.78v412.88l-23.78,23.78h-69.07l2.06,2.06h67.86l24.99-24.99V24.99L308.76,0ZM2.19,158.25c-1.21,0-2.19.98-2.19,2.19s.98,2.19,2.19,2.19,2.19-.98,2.19-2.19-.98-2.19-2.19-2.19ZM2.19,144.07c-1.21,0-2.19.98-2.19,2.19s.98,2.19,2.19,2.19,2.19-.98,2.19-2.19-.98-2.19-2.19-2.19ZM2.19,132.99c-1.21,0-2.19.98-2.19,2.19s.98,2.19,2.19,2.19,2.19-.98,2.19-2.19-.98-2.19-2.19-2.19ZM196.27,463.48c0-1.21-.98-2.19-2.19-2.19s-2.19.98-2.19,2.19.98,2.19,2.19,2.19,2.19-.98,2.19-2.19ZM210.45,463.48c0-1.21-.98-2.19-2.19-2.19s-2.19.98-2.19,2.19.98,2.19,2.19,2.19,2.19-.98,2.19-2.19ZM221.54,463.48c0-1.21-.98-2.19-2.19-2.19s-2.19.98-2.19,2.19.98,2.19,2.19,2.19,2.19-.98,2.19-2.19Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDev);
export default __webpack_public_path__ + "static/media/dev.a4a6de2f2b10dc8d492dfa0b7ee0bc61.svg";
export { ForwardRef as ReactComponent };